export default __webpack_public_path__ + "static/news_768-db90e3819762507b7794ecc8c0060060.jpg";